
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applicationTracker",
      function () {
        return require("private-next-pages/applicationTracker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applicationTracker"])
      });
    }
  